import React, { useEffect, useState } from "react"
import { NumericFormat } from "react-number-format"
import { useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import { useRouter } from "next/router"
import { getOrderDetailsUrlNonLoggedIn } from "@/utils"
import _isEmpty from "lodash/isEmpty"
import Button from "@/components/core/Button/Button"
import moment from "moment"
import { orderDetailsAnalytics } from "@/components/Shared/OrderHistory/v1/analytics"

const OrderTile = props => {
  const { i18n, type, data, info, orderType, authorData, ...restProps } = props
  const {
    orderNo = "",
    orderStatus = "",
    orderDate = "",
    totalItems = "",
    orderTotal = "",
    isImported = false,
    migratedOrderDate = "",
  } = data
  const { currencySign, orderDetailsUrl } = info
  const orderDetailsPage = `${orderDetailsUrl}?orderNumber=${orderNo}`
  const [loading, setLoading] = useState(false)

  const checkOrder = async () => {
    setLoading(true)

    let orderdetailsURL = ""
    orderdetailsURL = await getOrderDetailsUrlNonLoggedIn(orderNo)
    window.location.href = orderdetailsURL
    setLoading(false)
  }

  return (
    <div className="order-status__order-tile">
      <div className="order-status__details">
        <section className="order-status__order-no">
          <div className="order-status__label">{`${i18n.order} #`}</div>
          <div className="order-status__value">{`${
            isImported ? "SK-" + orderNo : orderNo
          }`}</div>
        </section>
        <section className="order-status__date">
          <div className="order-status__label">
            {type === "openOrders"
              ? // #ToDo showOrdersFromLabel is not implemented.
                i18n.orderCreatedOn(authorData?.columnOne ?? null)
              : i18n.orderCreatedOn(null)}
            {/* The Above line is commented as per the design changes  */}
          </div>
          <div className="order-status__value">
            {isImported
              ? moment(Date.parse(migratedOrderDate)).format("MM/DD/YYYY")
              : moment(Date.parse(orderDate)).format("MM/DD/YYYY")}
          </div>
        </section>
        <section className="order-status__items">
          <div className="order-status__label">{i18n.items}</div>
          <div className="order-status__value">{totalItems}</div>
        </section>
        <section className="order-status__total">
          <div className="order-status__label">{i18n.orderTotal}</div>
          <div className="order-status__value">
            <NumericFormat
              value={orderTotal}
              displayType={"text"}
              thousandSeparator={true}
              prefix={currencySign}
              decimalScale={restProps.orderTotal === 0 ? 0 : 2}
              fixedDecimalScale={true}
              thousandsGroupStyle={"lakh"}
            />
          </div>
        </section>
        <section className="order-status__status">
          <div className="order-status__label">{i18n.orderStatus}</div>
          <div className="order-status__value">{orderStatus}</div>
        </section>
      </div>
      <Button
        ariaLabel={`${
          type === "openOrders" ? i18n.openOrders : i18n.pastOrders
        } ${i18n.viewOrder} ${orderNo}`}
        className="gbh-data-layer"
        data-gbh-data-layer={orderDetailsAnalytics(
          orderType === "openOrders" ? "open" : "past",
          orderDetailsPage
        )}
        customClass="order-status__view-order"
        size="small"
        type="ghost"
        role="button"
        onClick={checkOrder}
        label={i18n.orderDetails}
        loading={loading}
      />
    </div>
  )
}

export default OrderTile
